module.exports = __webpack_public_path__ + "img/blood-2.70972070.png";